const steps = ["Verify", "Basics", "Category", "Scale & Support", "Review"];

export default function StepProgress({ current }) {
  return (
    <div className="flex items-center justify-between mb-10" data-testid="request-step-progress">
      {steps.map((label, i) => {
        const stepNum = i;
        const isActive = stepNum === current;
        const isDone = stepNum < current;
        return (
          <div key={label} className="flex items-center flex-1 last:flex-none">
            <div className="flex flex-col items-center gap-2">
              <div
                data-testid={`request-step-indicator-${i}`}
                className="w-9 h-9 rounded-full flex items-center justify-center text-sm font-semibold transition-all duration-300"
                style={{
                  backgroundColor: isDone ? "#194449" : isActive ? "#D4EC8E" : "#E2EBE9",
                  color: isDone ? "#fff" : isActive ? "#194449" : "#8B9694",
                }}
              >
                {isDone ? "\u2713" : i + 1}
              </div>
              <span
                className="text-[11px] font-medium uppercase tracking-wide hidden sm:block"
                style={{ color: isActive ? "#194449" : "#8B9694" }}
              >
                {label}
              </span>
            </div>
            {i < steps.length - 1 && (
              <div className="flex-1 h-[2px] mx-2 sm:mx-3 mb-5 sm:mb-6" style={{ backgroundColor: isDone ? "#194449" : "#E2EBE9" }} />
            )}
          </div>
        );
      })}
    </div>
  );
}
